import { COLLECTION_ACCESS } from '../../constants/accessControl';
// @ts-expect-error Untyped import
import { getRealmTemplateKeys } from '../../utils/reportingIAUtils';
import { checkAccessRequirements } from '../../utils/accessControlUtils';
export const groupTemplatesIntoPairs = templates => {
  const pairs = [];
  for (let i = 0; i < templates.length; i += 2) {
    const pair = templates.slice(i, i + 2);
    if (pair.length > 0) {
      pairs.push(pair);
    }
  }
  return pairs;
};
export const getAccessProperties = (id, gates, scopes) => {
  const accessControl = COLLECTION_ACCESS.get(id);
  const access = accessControl ? checkAccessRequirements({
    gates,
    scopes,
    accessControl
  }) : {
    isVisible: true,
    accessAllowed: true
  };
  const upgradePoint = COLLECTION_ACCESS.getIn([id, 'upgradePoint']);
  return {
    isVisible: access.isVisible,
    accessAllowed: access.accessAllowed,
    upgradePoint
  };
};
export const getTemplates = (templateId, gates, scopes, templatesByKey) => {
  const templateKeys = getRealmTemplateKeys(templateId, gates, scopes);
  if (templateKeys.length > 1) {
    return templateKeys.map(templateKey => templatesByKey.get(templateKey));
  } else {
    return [templatesByKey.get(templateKeys[0])];
  }
};
export const getCategoriesAndChildrenWithPermissions = (categoryIA, gates, scopes, templatesByKey) => {
  return categoryIA.map(category => {
    const categoryAccessProps = getAccessProperties(category.id, gates, scopes);
    const allTemplateResults = (category.children ? category.children.map(child => getTemplates(child.id, gates, scopes, templatesByKey)) : [getTemplates(category.id, gates, scopes, templatesByKey)]).flat();
    const templates = allTemplateResults.filter(template => template !== undefined);
    return {
      id: category.id,
      labelKey: `reports.sidebar.collections.${category.id}`,
      templates,
      accessProperties: categoryAccessProps
    };
  }).filter(category => {
    var _category$accessPrope, _category$accessPrope2;
    return ((_category$accessPrope = category.accessProperties) === null || _category$accessPrope === void 0 ? void 0 : _category$accessPrope.isVisible) && ( // TODO: remove once we have designs for upgrade points
    (_category$accessPrope2 = category.accessProperties) === null || _category$accessPrope2 === void 0 ? void 0 : _category$accessPrope2.accessAllowed);
  });
};